import { render, staticRenderFns } from "./EditorJs.vue?vue&type=template&id=75ff8e64&"
import script from "./EditorJs.vue?vue&type=script&lang=js&"
export * from "./EditorJs.vue?vue&type=script&lang=js&"
import style0 from "./EditorJs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports